<template>
  <layout-main-inner title="快检统计">
    <inspect-data />
    <inspect-time-data />
  </layout-main-inner>
</template>

<script>
import InspectData from '../home/inspect-data.vue'
import InspectTimeData from '../home/inspect-time-data.vue'
export default {
  name: 'StatInspect',
  components: {
    InspectData, InspectTimeData
  }
}
</script>

<style>

</style>
